import { __ } from '../../../locales'

const SmallerViewFilter = ({ inputs, onInputsChange }) => {
    const rand = Math.random()

    return (
        <div className={'input-component row'}>
            <input
                id={'smaller-filter' + rand}
                type="checkbox"
                className="form-control"
                checked={inputs.smaller}
                onInput={(ev) => onInputsChange('smaller', ev.target.checked)}
            />
            <label for={'smaller-filter' + rand} dangerouslySetInnerHTML={{ __html: `${__('inputs.smaller_version.label')}:` }} />
        </div>
    );
};

export default SmallerViewFilter;
